export var ToggleDisplayMode;
(function (ToggleDisplayMode) {
    ToggleDisplayMode[ToggleDisplayMode["None"] = 0] = "None";
    ToggleDisplayMode[ToggleDisplayMode["Active"] = 1] = "Active";
    ToggleDisplayMode[ToggleDisplayMode["Disabled"] = 2] = "Disabled";
    ToggleDisplayMode[ToggleDisplayMode["Hidden"] = 3] = "Hidden";
})(ToggleDisplayMode || (ToggleDisplayMode = {}));
